module.exports = __webpack_public_path__ + "img/patient-chat.a23e0af9.svg";